
import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {downloadCsv} from "@/helpers/csvHelper";
import SimpleAlertDialog from "@/components/shared/SimpleAlertDialog.vue";

const ROW_LIMIT = 1000;

@Component({
  components: {
    SimpleAlertDialog,
  }
})
export default class CsvDownloader extends Vue {
  @Prop({required: true})
  private fetchData!: () => Promise<any[]>;

  @Prop({required: true})
  private headers!: string[];

  @Prop({required: true})
  private mapRow!: (item: any) => Array<string | number | null | undefined>;

  @Prop({required: true})
  private fileName!: string;

  @Prop({default: true})
  private visible!: boolean;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: ''})
  private hint!: string;

  @Prop({default: ''})
  private limitTitle!: string;

  @Prop({default: ''})
  private limitText!: string;

  @Prop({default: null})
  private fetchCount!: (() => Promise<number>) | null;

  private downloading: boolean = false;
  private showLimitDialog: boolean = false;

  private async onDownload() {
    this.downloading = true;
    try {
      if (this.fetchCount) {
        const count = await this.fetchCount();
        if (count >= ROW_LIMIT) {
          this.showLimitDialog = true;
          return;
        }
      }
      const rawData = await this.fetchData();
      const data = this.normalizePayload(rawData);
      const rows = data.map(this.mapRow);
      downloadCsv(this.headers, rows, this.fileName);
    } catch (e) {
      // fetch failed silently (fetchData should handle its own errors)
    } finally {
      this.downloading = false;
    }
  }

  private normalizePayload(payload: any): any[] {
    if (Array.isArray(payload)) {
      return payload;
    }
    if (payload && Array.isArray(payload.data)) {
      return payload.data;
    }
    return [];
  }
}
